<template>
    <Head title="Liste des demandes d'envoie de colis" />

    <AppLayout>
        <div x-data="handleSelect">
            <Datatables>
                <template #title>
                    Liste des demandes d'envoie de colis
                    <span class="font-medium">({{ requests.total }})</span>
                </template>
                <template #headerButtons>
                    <button class="rounded-md py-1 px-2 bg-white text-sky hover:bg-sky-400 hover:text-white"
                        @click="showSearchModal" title="Rechercher"
                    >
                        <i class="fad fa-search"></i>
                    </button>
                </template>
                <template #tableHeader>
                    <th>#</th>
                    <th>Code</th>
                    <th>Demandeur</th>
                    <th>Envoyée le</th>
                    <th># Colis</th>
                    <th>Statut</th>
                    <th class="px-2 first:pl-5 last:pr-5 py-3">
                        <span class="sr-only">Menu</span>
                    </th>
                </template>
                <template #tableBody>
                    <template v-if="!requests.data.length">
                        <tr>
                            <td colspan="7">
                                <div class="text-center text-xl text-red-400 bg-red-100 p-8">
                                    Aucune demande d'envoie de colis effectuée.
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-else v-for="(req, index) in requests.data" :key="index">
                        <tr>
                            <td>{{ index + 1 }}</td>
                            <td>{{ req.code }}</td>
                            <td>
                                <div class="flex items-center">
                                    <div class="shrink-0 flex items-center justify-center rounded-full mr-2"
                                        :class="req.user ? 'bg-gray-500' : 'bg-primaryOrange'"
                                    >
                                        <img class="w-10 h-10 rounded-full border-2 box-content" :class="req.user ? 'border-white' : ''"
                                            :src="req.user ? req.user.profile_photo_url : '/images/new.png'"
                                        />
                                    </div>

                                    <div class="grow text-left">
                                        <h2 class="font-semibold inline-flex" :class="req.user ? 'text-sky' : 'text-gray-800'">
                                            {{ req.user ? req.user.name : req.requester_name }}
                                        </h2>
                                        <div class="text-xs text-gray-500 font-semibold">
                                            {{ req.user ? req.user.full_phone : (req.full_phone || 'Numéro non défini') }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="capitalize">{{ formattedDateTime(req.created_at) }}</td>
                            <td>{{ req.weight_package ? req.weight_package : 'Non défini' }}</td>
                            <td><StatusBadge :label="req.status_text" :color="req.status_color" /></td>
                            <td>
                                <Link class="flex justify-end" :href="route('travels.requests', req.travel) + '?filter[code]=' + req.code"
                                    title="Détails"
                                >
                                    <svg class="shrink-0 h-6 w-6" viewBox="0 0 24 24">
                                        <path class="fill-current text-sky" d="M8.07 16H10V8H8.07a8 8 0 110 8z"></path>
                                        <path class="fill-current text-sky-300" d="M15 12L8 6v5H0v2h8v5z"></path>
                                    </svg>
                                </Link>
                            </td>
                        </tr>
                    </template>
                </template>
            </Datatables>
        </div>

        <Pagination :links="requests.links" />

        <JetDialogModal :show="searchModal" @close="closeSearchModal" max-width="xl">
            <template #title>Recherche une demande</template>

            <template #content>
                <GlobalFilter @search-launched="closeSearchModal" />
            </template>
        </JetDialogModal>
    </AppLayout>
</template>

<script>
    import { defineComponent } from 'vue'
    import AppLayout from '@/Layouts/AppLayout.vue'
    import Pagination from '@/Components/Pagination'
    import Datatables from '@/Components/Datatables'
    import StatusBadge from '@/Components/StatusBadge'
    import PackageForm from '@/Components/PackageForm'
    import JetDialogModal from '@/Jetstream/DialogModal'
    import GlobalFilter from '@/Components/GlobalFilter'
    import { Head, Link } from '@inertiajs/inertia-vue3';
    import DateFormatMixins from '@/Mixins/DateFormatMixins'

    export default defineComponent({
        components: {
            Head,
            Link,
            AppLayout,
            Pagination,
            Datatables,
            StatusBadge,
            PackageForm,
            GlobalFilter,
            JetDialogModal
        },
        
        mixins: [ DateFormatMixins],

        props: {
            modes: Array,
            requests: Object
        },

        data() {
            return {
                selectedRequest: null,
                searchModal: false
            }
        },

        methods: {
            showSearchModal () {
                this.searchModal = true
            },

            closeSearchModal() {
                this.searchModal = false
            },
        }
    })
</script>
